module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_vm._v("Objects have always been carried, sold, bartered, stolen, retrieved and lost. People have always given gifts. It is how you tell their stories that matters.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—")]), _vm._v("Edmund de Waal, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Hare with Amber Eyes: A Family’s Century of Art and Loss")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0